import { Disposition } from './../../models/disposition';
import { OmsService } from './../../utils/services/oms.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Commission } from './../../models/commission';
import { CommissionService } from './../../utils/services/commission.service';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ShopService } from '../../utils/services/shop.service';
import { ShopOrderInfo } from '../../models/shop-order-info';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { StatusInfoDialogComponent } from '../../views/status-info-dialog/status-info-dialog.component';
import { Order } from 'src/app/models/order';

@Component({
  selector: 'app-commission-details',
  templateUrl: './commission-details.component.html',
  styleUrls: ['./commission-details.component.scss'],
})
export class CommissionDetailsComponent implements OnInit, AfterViewInit {
  public isLoading = true;
  public dispositionId: number;
  public orderId: number;
  public disposition: Disposition;
  // public commissions: Commission[];
  public order: Order;
  public shopOrderInfo: ShopOrderInfo;
  public dataSource = new MatTableDataSource<Commission>([]);
  public displayedColumns: string[] = [
    'id',
    'commissionType',
    'amount',
    'state',
    'isSent',
    'remarks',
  ];

  @ViewChild(MatPaginator)
  public paginator: MatPaginator;

  @ViewChild(MatSort)
  public sort: MatSort;

  public isCommissionLoading: boolean;

  constructor(
    private readonly commissionService: CommissionService,
    private readonly shopService: ShopService,
    private readonly omsService: OmsService,
    private readonly activeRoute: ActivatedRoute,
    private readonly router: Router,
    public dialog: MatDialog
  ) {
    this.shopOrderInfo = new ShopOrderInfo();
    this.disposition = new Disposition();
    this.order = new Order();
    this.order.commissionDTOList = [];
  }
  ngAfterViewInit(): void {
    this.loadData();
  }

  ngOnInit(): void {
    this.activeRoute.params.subscribe({
      next: (params) => {
        // this.dispositionId = params.id;
        this.orderId = params.orderId;
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  reset() {
    this.disposition = new Disposition();
    this.disposition.id = this.dispositionId;
    this.order = {};
  }

  creditCommission(event) {
    this.isCommissionLoading = true;
    this.commissionService.sendCommission(this.disposition.id).subscribe({
      next: (commission) => {
        console.log(commission);
        this.isCommissionLoading = false;
        this.router.navigate(['orders', 'commission', 'pending']);
      },
      error: (err) => {
        console.error(err);
        this.isCommissionLoading = false;
      },
    });
  }

  updatedCommissionsEvent() {
    this.reset();
    this.loadData();
  }

  openStatusInfoDialog() {
    const ref = this.dialog.open(StatusInfoDialogComponent, {});

    ref.afterClosed().subscribe({
      next: (result) => {
        console.log(result);
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  loadData() {
    this.isLoading = true;
    this.omsService.getDispositionByOrderId(this.orderId).subscribe({
      next: (order) => {
        this.disposition = order.dispositionDTO;
        this.order = order;
        this.dispositionId = this.disposition.id;
        // this.commissions = order.commissionDTOList;
      },
      error: (err) => {
        console.error(err);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
    this.shopService.getOrderInfo(this.orderId).subscribe({
      next: (shopOrderInfo) => {
        this.shopOrderInfo = shopOrderInfo;
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  setDataSource() {
    this.dataSource = new MatTableDataSource<Commission>(
      this.order.commissionDTOList
    );
    this.dataSource.paginator = this.paginator;
    if (this.sort) {
      this.dataSource.sort = this.sort;
      this.sort.sort({
        id: 'formattedLastModifiedDate',
        start: 'desc',
        disableClear: true,
      });
    }
  }
}
